<div class="gp-wrap">
  <h3 class="gp-heading" *ngIf="heading">{{ heading }}</h3>

  <div class="gradient-preview">
    <!-- The live preview with a draggable caret riding along it. Drag anywhere on the
         bar and the readout below shows the exact color under the caret. -->
    <div class="gp-stage" (pointerdown)="onDown( $event )"
         (pointermove)="onMove( $event )" (pointerup)="onUp( $event )">
      <div #bar class="gp-preview" [style.background]="gradientCss"></div>
      <div class="gp-caret" [style.left.%]="caretPos" tabindex="0" role="slider"
           aria-label="Sample the gradient" aria-valuemin="0" aria-valuemax="100"
           [attr.aria-valuenow]="caretPos | number:'1.0-0'" [attr.aria-valuetext]="caretHex"
           (keydown)="onKey( $event )">
        <span class="gp-caret-arrow"></span>
        <span class="gp-caret-line"></span>
      </div>
    </div>

    <!-- The color under the caret. -->
    <div class="gp-readout">
      <span class="gp-readout-swatch" [style.background]="caretHex"></span>
      <span class="gp-readout-hex">{{ caretHex }}</span>
    </div>

    <!-- A color picker per stop, hex below. Edit either end and the blend updates. -->
    <div class="gp-stops">
      <div class="gp-stop" *ngFor="let stop of stops; let i = index">
        <label class="gp-swatch" [style.background]="stop">
          <input type="color" class="gp-input" [value]="stop"
                 (input)="onColor( i, $any( $event.target ).value )"
                 [attr.aria-label]="'Color stop ' + ( i + 1 )">
        </label>
        <span class="gp-hex">{{ stop }}</span>
      </div>
    </div>
  </div>
</div>
